<template>
  <div class="full-board-title">
    <div class="describe">
      <i class="el-icon-info" style="margin-right: 6px"></i>
      <el-popover placement="bottom" width="200" trigger="hover">
        <div style="display:grid">
          <div style="margin-bottom:3px">
            数据源：
            <span style="color: #1989FA">{{ figure.dataSource }}</span>
          </div>
          <div v-if="figure.xAxisList" style="margin-bottom:3px">
            {{ figure.type === "map" ? "区域" : "X轴：" }}
            <span style="color: #1989FA" v-for="(xAxis, index) in figure.xAxisList" :key="index">
              {{ xAxis.name }}
              <span v-if="xAxis.projectType">
                {{ "[" + xAxis.projectType + "]" }}
              </span>
            </span>
          </div>
          <div v-if="figure.yAxisList">
            {{ figure.type === "map" ? "指标" : "y轴：" }}
            <span style="color: #1989FA" v-for="(yAxis, index) in figure.yAxisList" :key="index">
              {{ yAxis.name }}
              <span v-if="yAxis.groupType" style="color: #1989FA">
                {{ "[" + yAxis.groupType + "]" }}
              </span>
              {{ " " }}
            </span>
          </div>
        </div>
        <span slot="reference" style="margin-right: 6px; font-size: 14px">指标详情</span>
      </el-popover>
      <el-radio-group v-model="figure.type" style="display:flex; margin-right: 20px">
        <el-radio-button
          v-for="(chart, index) in chartList"
          :key="index"
          :label="chart.value"
          v-show="!chart.disabled"
        >
          <el-tooltip class="item" effect="dark" :content="chart.name" placement="bottom">
            <svg-icon :icon-class="'chart_' + chart.value" class="svg-item"></svg-icon>
          </el-tooltip>
        </el-radio-button>
      </el-radio-group>
    </div>
    <div class="filter" v-if="filterVisible">
      <div class="filter-info">
        <svg-icon icon-class="board_selected-filter" style="margin-right: 6px"></svg-icon>
        <span style="color: #1989FA; font-size: 14px" @click="setFilter">数值范围</span>
      </div>
    </div>
    <div class="tip">
      <div>最后更新时间：{{ figure.syncTime }}</div>
    </div>
  </div>
</template>

<script>
import { chartList } from "@/views/Backend/Admin/Statistics/chartEdit/static"

export default {
  name: "full-board-title",
  props: {
    figure: {
      type: Object,
      required: true
    },
    filterVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chartList
    }
  },
  methods: {
    setFilter() {
      this.$emit("setFilter")
    }
  }
}
</script>

<style lang="scss" scoped>
.full-board-title {
  display: flex;
  position: relative;
  margin-top: 52px;
  height: 52px;
  padding: 0 20px;
  background: white;
  border-bottom: 1px solid #e4e4e4;
  .describe {
    display: flex;
    align-items: center;
    .icon {
      font-size: 24px;
      height: 30px;
      width: 30px;
      text-align: center;
      margin-right: 8px;
      &:hover {
        border-radius: 4px;
        box-shadow: 0 0 2px 3px #d7e9fc;
      }
      &:last-child {
        margin-right: 20px;
      }
    }
  }
  .filter {
    display: flex;
    align-items: center;
    .filter-info {
      cursor: pointer;
      border-left: #dcdfe6 solid 1px;
      padding-left: 20px;
    }
  }
  .tip {
    margin-left: auto;
    font-size: 13px;
    display: flex;
    align-items: center;
    color: #c0c4cc;
  }
  ::v-deep .el-radio-button:first-child .el-radio-button__inner {
    border-left: 2px solid #ffffff;
  }
  ::v-deep .el-radio-button__inner {
    border-radius: 4px !important;
    border: 2px solid #ffffff;
    padding: 0;
    box-shadow: none !important;
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: white;
    border-color: #409eff !important;
  }
  ::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    border-color: #ffffff;
  }
  .svg-item {
    height: 23px;
    width: 23px;
    padding: 4px;
  }
}
</style>
